// Elite custom start: restore lazy header templates when body init attrs are stripped.
(() => {
  if (window.EliteHeaderInitLoaded) return;
  window.EliteHeaderInitLoaded = true;

  document.addEventListener('alpine:init', () => {
    const dispatchEliteThemeInit = () => {
      const initStore = Alpine.store('xInit');
      if (initStore && initStore.runDispatch) {
        window.dispatchEvent(new CustomEvent('init-run'));
        initStore.runDispatch = false;
      }
    };

    document.addEventListener('mouseover', () => {
      dispatchEliteThemeInit();
      const popupStore = Alpine.store('xPopup');
      if (popupStore && popupStore.setWidthScrollbar) popupStore.setWidthScrollbar();
    });
    document.addEventListener('touchstart', dispatchEliteThemeInit, { passive: true });
  });
})();
// Elite custom end
